import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FiChecklist2ReportType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';
import { IChecklistV2ReportParameter } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { Animations } from '@fi-shared/utils/animations';
import { FiChecklistSectionTypes } from '@fi-shared/checklist';
import { IChecklist2ReportViewData } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report-data';
import { FiChecklist2ReportDialogsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-dialogs.service';
import { FiValuesComparison } from '@fi-shared/utils/fi-values-comparison';
import { FiChecklist2ReportService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report.service';
import { Subject } from 'rxjs';
import { NewWidgetDialogBaseDirective } from '@fi-shared/fi-report-widget/new-report-widget-dialog/new-widget-dialog-base';

@Component({
    selector: 'fi-checklist2-report-new-widget-dialog',
    templateUrl: './fi-checklist2-report-new-widget-dialog.component.html',
    styleUrls: ['./fi-checklist2-report-new-widget-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-report-new-widget-dialog' },
    animations: [Animations.fade],
    standalone: false,
})
export class FiChecklist2ReportNewWidgetDialogComponent
    extends NewWidgetDialogBaseDirective<FiChecklist2ReportType, IChecklistV2ReportParameter>
    implements OnInit, OnDestroy
{
    private readonly fiChecklist2ReportDialogsService = inject(FiChecklist2ReportDialogsService);
    private readonly fiChecklist2ReportService = inject(FiChecklist2ReportService);

    private fiValuesComparison: FiValuesComparison<IChecklistV2ReportParameter>;

    protected get reportData(): IChecklist2ReportViewData {
        return this.fiChecklist2ReportDialogsService.getNewWidgetReportData();
    }

    public ngOnInit() {
        this.fiValuesComparison = new FiValuesComparison(() => this.reportWidget);
        this.subscribeOnTransitionCloseDialog(this.fiDialogsService, this.ngOnDestroy$);
        super.ngOnInit();
    }

    private getNewReportParameter(): IChecklistV2ReportParameter {
        return {
            Id: 0,
            Name: '',
            Description: '',
            ReportType: this.currentReportWidgetType,
            SortIndex: this.reportData.reportsCount,
            Settings: {
                CurrentFilterGuid: undefined,
                Filters: [],
            },
        };
    }

    protected saveWidget($event: IChecklistV2ReportParameter): void {
        this.fiChecklist2ReportDialogsService
            .showConfirmSaveNewReportWidget()
            .onYesButtonClick(() => {
                super.saveWidget($event);
            });
    }

    protected getCanCloseWithoutConfirmation(): boolean {
        return !this.fiValuesComparison.isChanged();
    }

    protected createCurrentReportWidget(): void {
        const reportWidget: IChecklistV2ReportParameter = this.getNewReportParameter();
        this.loading.set(true);
        this.fiChecklist2ReportService
            .getDataForReportParameter(reportWidget, this.reportData.auditMode)
            .then((reportData) => {
                this.reportData.setReportData(reportData, reportWidget.Id);
                this.reportWidget = reportWidget;
                this.loading.set(false);
            })
    }

    private readonly ngOnDestroy$ = new Subject<void>();
    public ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    protected readonly FiChecklist2ReportType = FiChecklist2ReportType;
    protected readonly FiChecklistSectionTypes = FiChecklistSectionTypes;
}
